import type { MenuConfig } from '~typings/menu'

import { permissionTree as permisos, RESOURCE_PRODUCCION_PG } from '@/auth/permissions/modules/produccionPg'
import {
    ROUTE_PPG_ALERTACORREO,
    ROUTE_PPG_COSTOPROCESO,
    ROUTE_PPG_NIVELAPROBACIONOP,
    ROUTE_PPG_NIVELAPROBACIONPRODUCTO,
    ROUTE_PPG_PRODUCTOBASE,
} from '@/router/routes/producion-pg/nombres'
import { defineMenu } from '@/utils/menu'

const { configuracion } = permisos
export default defineMenu([
    {
        title: 'produccion_pg.subopciones.producto_base',
        resource: RESOURCE_PRODUCCION_PG,
        action: configuracion.producto_base,
        route: ROUTE_PPG_PRODUCTOBASE,
    },
    {
        title: 'produccion_pg.subopciones.nivel_aprobacion_producto',
        resource: RESOURCE_PRODUCCION_PG,
        action: configuracion.nivel_aprobacion_producto,
        route: ROUTE_PPG_NIVELAPROBACIONPRODUCTO,
    },
    {
        title: 'produccion_pg.subopciones.nivel_aprobacion_op',
        resource: RESOURCE_PRODUCCION_PG,
        action: configuracion.nivel_aprobacion_op,
        route: ROUTE_PPG_NIVELAPROBACIONOP,
    },
    {
        title: 'produccion_pg.subopciones.alerta_correo',
        resource: RESOURCE_PRODUCCION_PG,
        action: configuracion.alerta_correo,
        route: ROUTE_PPG_ALERTACORREO,
    },
    {
        title: 'produccion_pg.subopciones.costo_proceso',
        resource: RESOURCE_PRODUCCION_PG,
        action: configuracion.costo_proceso,
        route: ROUTE_PPG_COSTOPROCESO,
    },
] as MenuConfig[])
